import { ElementType } from 'react';

import {
    betaStatisticsBackendUnavailable,
    BETA_STATISTICS_BACKEND_UNAVAILABLE,
} from 'src/components/ReportFetcher/Notifications';

import defaultError, { DEFAULT_ERROR } from 'src/components/Notifications/DefaultError';
import downloadReportError, { DOWNLOAD_REPORT_ERROR } from 'src/components/Notifications/DownloadReportError';
import filterMoreThanOneYear, { FILTER_MORE_THAN_ONE_YEAR } from 'src/components/Notifications/FilterMoreThanOneYear';
import networkError, { NETWORK_ERROR } from 'src/components/Notifications/NetworkError';
import successSendFeedback, { SUCCESS_SEND_FEEDBACK } from 'src/components/Notifications/SuccessSendFeedback';
import { NotificationKind } from 'src/components/Notifications/types';

interface VariantsProps {
    Element: ElementType;
    label?: string;
    kind: NotificationKind;
    autoClose: boolean;
    hideClose?: boolean;
    onClose?: () => void;
}

const variants: Record<string, VariantsProps> = {
    [DEFAULT_ERROR]: defaultError,
    [NETWORK_ERROR]: networkError,
    [BETA_STATISTICS_BACKEND_UNAVAILABLE]: betaStatisticsBackendUnavailable,
    [DOWNLOAD_REPORT_ERROR]: downloadReportError,
    [FILTER_MORE_THAN_ONE_YEAR]: filterMoreThanOneYear,
    [SUCCESS_SEND_FEEDBACK]: successSendFeedback,
};

export default variants;
